<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn color="primary" v-bind="props">
        {{title}}
      </v-btn>
    </template>
    <v-list>
      <template v-for="(item, index) in items" :key="index">
        <v-list-item v-if="item.link" :to="item.link">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
        <v-list-item v-else @click="item.onClick">
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    title: {
      required: true
    },
    items: {
      required: true
    }
  }
}
</script>
